const PREFIX = 'vorbello_e2ee_key_v1:';
function keyName(organizationId: string, meetingId: string): string {
  if (!/^[a-zA-Z0-9_-]{1,128}$/.test(organizationId) || !/^meet-[a-f0-9]{32}$/.test(meetingId)) throw new Error('Identitatea întâlnirii criptate este invalidă.');
  return `${PREFIX}${organizationId}:${meetingId}`;
}
/** Local device storage; not protected against same-origin script or device compromise. */
export function saveMeetingE2eeKey(store: Pick<Storage, 'setItem'>, organizationId: string, meetingId: string, key: Uint8Array): void {
  if (!(key instanceof Uint8Array) || key.length !== 32) throw new Error('Cheie invalidă.');
  const encoded = btoa(Array.from(key, value => String.fromCharCode(value)).join(''));
  store.setItem(keyName(organizationId, meetingId), encoded);
}
export function loadMeetingE2eeKey(store: Pick<Storage, 'getItem'>, organizationId: string, meetingId: string): Uint8Array | null {
  const saved = store.getItem(keyName(organizationId, meetingId));
  if (saved === null) return null;
  if (!/^[A-Za-z0-9+/]{43}=$/.test(saved)) throw new Error('Cheia salvată este invalidă.');
  const decoded = atob(saved);
  if (decoded.length !== 32 || btoa(decoded) !== saved) throw new Error('Cheia salvată este invalidă.');
  return Uint8Array.from(decoded, value => value.charCodeAt(0));
}
